module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0119.jpg?v=aba0b204";